import { useIntl } from "react-intl";

function EditIndustrySpecialistSkeleton() {
  const intl = useIntl();

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="inputs-container skeleton-container"
    >
      <span id="skeleton-loading" className="visually-hidden">
        {intl.formatMessage({ id: "customComponents.loading" })}
      </span>
      <div className="usadmin-input-name skeleton-block" />
      <div className="usadmin-input-contactName skeleton-block" />
      <div className="first-column skeleton-button" />
    </div>
  );
}

export default EditIndustrySpecialistSkeleton;
